import { insuranceClassEdit, insuranceClassAdd } from './request';
export default {
  data() {
    return {
      addVisible: false,
      addForm: {
        name: '',
        sort: null
      },
      status: ''
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品大类'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }],
        sort: [{
          required: true,
          message: this.$t('请输入') + this.$t('排序数'),
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    openModal(type, info) {
      this.status = type;
      this.emptyForm();
      if (info) {
        Object.assign(this.addForm, info);
      }
      this.addVisible = true;
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          const saveURL = this.status === 'add' ? insuranceClassAdd : insuranceClassEdit;
          if (this.status === 'add') {
            this.addForm.insuranceSortId = null;
          }
          await saveURL(this.addForm);
          this.$message.success(this.$t('保存成功') + '!');
          this.addVisible = false;
          this.$emit('save');
        }
      });
    },
    closeAddVisible() {
      this.addVisible = false;
      this.continueState = false;
      this.emptyForm();
      this.resetForm();
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    },
    emptyForm() {
      this.addForm.insuranceSortId = null;
      this.addForm.name = '';
      this.addForm.sort = '';
    }
  }
};